import React, { useState } from 'react';
import { FixMe } from '../../types/util';
export interface IUploadContext {
  label: string;
  setLabel: (value: string) => void;
  open: boolean;
  setOpen: (value: boolean) => void;
  uploaded: boolean;
  setUploaded: (value: boolean) => void;
  uploading: boolean;
  setUploading: (value: boolean) => void;
  display: boolean;
  setDisplay: (value: boolean) => void;
  step: number;
  setStep: (value: number) => void;
  option: number;
  setOption: (value: number) => void;
  acceptedDocs: FixMe;
  setAcceptedDocs: (values: FixMe) => void;
  totalAcceptedDocs: number;
  updateTotalAcceptedDocs: React.Dispatch<React.SetStateAction<number>>;
  totalUploadedDocs: number;
  updateTotalUploadedDocs: React.Dispatch<React.SetStateAction<number>>;
  totalFailedDocs: number;
  updateTotalFailedDocs: React.Dispatch<React.SetStateAction<number>>;
  isExperimental: boolean;
  setIsExperimental: (value: boolean) => void;
}

export const UploadContext = React.createContext({} as IUploadContext);

export const UploadContextProvider = ({ children }: any) => {
  const [label, setLabel] = useState('');
  const [uploaded, setUploaded] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [open, setOpen] = useState(false);
  const [display, setDisplay] = useState(true);
  const [step, setStep] = useState(1);
  const [option, setOption] = useState(0);
  const [acceptedDocs, setAcceptedDocs] = useState([]);
  const [totalAcceptedDocs, updateTotalAcceptedDocs] = useState(0);
  const [totalUploadedDocs, updateTotalUploadedDocs] = useState(0);
  const [totalFailedDocs, updateTotalFailedDocs] = useState(0);
  const [isExperimental, setIsExperimental] = useState(false);

  return (
    <UploadContext.Provider
      value={{
        label,
        setLabel,
        open,
        setOpen,
        uploaded,
        setUploaded,
        uploading,
        setUploading,
        display,
        setDisplay,
        step,
        setStep,
        acceptedDocs,
        setAcceptedDocs,
        totalAcceptedDocs,
        updateTotalAcceptedDocs,
        totalUploadedDocs,
        updateTotalUploadedDocs,
        totalFailedDocs,
        updateTotalFailedDocs,

        option,
        setOption,
        isExperimental,
        setIsExperimental,
      }}
    >
      {children}
    </UploadContext.Provider>
  );
};
